// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"b7fa592e","398":"f665c1a8","440":"15bc58f2","458":"ea7ac006","488":"ea6730d2","990":"214fcb64"}[chunkId] + ".chunk.js";
};